import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import "./NoData";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";

const ChargeFifth = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [refreshDate, setRefreshDate] = useState("");
  // const [appydata, setappydata] = useState([]);
  const [city, setCity] = useState([]);
  const [airVentilation, setAirVentilation] = useState();
  const [PLValue, setPLValue] = useState();
  const [totalCount, setTotalCount] = useState();
  const [drivenVehicles, setdrivenVehicles] = useState();
  const [chargedCycles, setChargedCycles] = useState();
  const [faultyCycles, setFaultyCycles] = useState();
  const [interrCycles, setInterrCycles] = useState();
  const [opporCycles, setOpporCycles] = useState();
  const [fullCycles, setFullCycles] = useState();
  const [maxPackA, setMaxPackA] = useState();
  const [maxPackB, setMaxPackB] = useState();
  const [maxPackC, setMaxPackC] = useState();
  const [maxPackD, setMaxPackD] = useState();
  const [vinCount, setVinCount] = useState(0);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      city,
      airVentilation,
      PLValue,
      totalCount,
      drivenVehicles,
      chargedCycles,
      faultyCycles,
      interrCycles,
      opporCycles,
      fullCycles,
      maxPackA,
      maxPackB,
      maxPackC,
      maxPackD,
      vinCount,
    }),
  }));

  useEffect(() => {
    fetchData(
      {
        url:
          API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus",
        body: {},
      },
      refreshDateData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/fifthpagepdf",
        body: { filterdata: gloablfilter, IND },
      },
      appyData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/secondpage_total_count_pdf",
        body: { filterdata: gloablfilter },
      },
      tablecountfunc
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/fifthpagecount",
        body: { filterdata: gloablfilter },
      },
      totalcountfunc
    );
  }, [gloablfilter]);

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  };

  const appyData = (data) => {
    setCity(data.uniqueCities);
    setAirVentilation(data.airVent);
    setPLValue(data.PLval);
    setdrivenVehicles(data.drivenVehicles);
    setChargedCycles(data.chargedCycles);
    setFaultyCycles(data.faultyCycles);
    setInterrCycles(data.interruptDuration);
    setOpporCycles(data.opportunityCycles);
    setFullCycles(data.fullCycles);
    setMaxPackA(data.A_Max);
    setMaxPackB(data.B_Max);
    setMaxPackC(data.C_Max);
    setMaxPackD(data.D_Max);
  };

  const tablecountfunc = (data) => {
    setTotalCount(data);
  };

  const totalcountfunc = (data) => {
    setVinCount(data[0].vehicleId.value);
  };

  const getTotalVehicleCount = (cityName, PL) => {
    if (!Array.isArray(totalCount)) {
      // console.error('totalCount is not an array:', totalCount);
      return "-";
    }
    // Extract the part of PL after the first underscore
    const [, PLValue] = PL.split("_");
    const match = totalCount.find(
      (item) => item.key.DLR_ORG_CITY === cityName && item.key.PL === PLValue
    );
    return match ? match.total_vehicle_count.value : "-";
  };

  const getDrivenVehicleValue = (cityName, PL) => {
    // Extract the part of PL after the first underscore
    // const PLParts = PL.split('_');
    // const PLValue = PLParts.length > 1 ? PLParts[1] : PLParts[0];
    // // Construct the key used in drivenVehicles
    // const drivenVehicleKey = `${cityName}_${PLValue}`;
    return drivenVehicles[PL] || "-";
  };

  return (
    <div className="fifthpage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>

      <div className="row mt-3">
        <div className="col-md-6">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Charge Analytics:{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div
        className="row mt-3"
        style={{ marginLeft: "20px", marginRight: "20px" }}
      >
        {isLoading ? (
          <ChartLoader />
        ) : Object.keys(city).length > 0 ? (
          <>
            <table
              className="pdftable"
              id="slide3Table"
              style={{ color: "black", fontSize: "18px" }}
            >
              <tr style={{ backgroundColor: "#e2f0d9" }}>
                <th style={{ fontSize: "18px" }}></th>
                {city.map((cityName, index) => (
                  <th key={index}>{cityName}</th>
                ))}
              </tr>
              {/* <tr>
              <td>Vehicle Type</td>
              {city.map((cityName, index) => (
                <td key={index}>{PLValue[cityName]}</td>
              ))}
            </tr> */}
              <tr style={{ backgroundColor: "#e2f0d9" }}>
                <td>Vehicle Type</td>
                {PLValue.map((cityName, index) => {
                  const value = PLValue[index];
                  const stringValue =
                    typeof value === "string" ? value : String(value || "");
                  // Extract numeric values using regular expression
                  const numericValue =
                    stringValue.match(/[\d/]+/g)?.join("") || "";
                  return <td key={index}>{numericValue}</td>;
                })}
              </tr>

              <tr style={{ backgroundColor: "#e2f0d9" }}>
                <td>Charge Analytics</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{airVentilation[cityName]}</td>
                ))}
              </tr>

              <tr>
                <td>Total|Charged Vehicle</td>
                {city.map((cityName, index) => {
                  const PL = PLValue[index];
                  const totalCountValue = getTotalVehicleCount(cityName, PL);
                  const drivenVehicleValue = getDrivenVehicleValue(
                    cityName,
                    PL
                  );
                  // const drivenVehicleValue = drivenVehicles[cityName] || '-';
                  return (
                    <td key={index}>
                      {totalCountValue} | {drivenVehicleValue}
                    </td>
                  );
                })}
              </tr>
              {/* <tr>
              <td>Driven Vehicl</td>
              {city.map((cityName, index) => (
                <td key={index}>{drivenVehicles[cityName]}</td>
              ))}
            </tr> */}
              <tr>
                <td>Total charged cycles</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{chargedCycles[cityName]}</td>
                ))}
              </tr>
              <tr>
                <td>Critical faulty cycles</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{faultyCycles[cityName]}</td>
                ))}
              </tr>
              <tr>
                <td>Interruption cycles</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{interrCycles[cityName]}</td>
                ))}
              </tr>
              <tr>
                <td>Opportunity charged cycles</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{opporCycles[cityName]}</td>
                ))}
              </tr>
              <tr>
                <td>Full charged cycles</td>
                {PLValue.map((cityName, index) => (
                  <td key={index}>{fullCycles[cityName]}</td>
                ))}
              </tr>
              <tr>
                <td>Max Temp - Pack A (°C) </td>
                {PLValue.map((cityName, index) => (
                  // <td key={index}>{maxPackA[cityName]} °C</td>
                  <td key={index}>
                    {maxPackA[cityName] !== null
                      ? `${maxPackA[cityName]} °C`
                      : "-"}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Max Temp - Pack B (°C) </td>
                {PLValue.map((cityName, index) => (
                  // <td key={index}>{maxPackB[cityName]} °C</td>
                  <td key={index}>
                    {maxPackB[cityName] !== null
                      ? `${maxPackB[cityName]} °C`
                      : "-"}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Max Temp - Pack C (°C) </td>
                {PLValue.map((cityName, index) => (
                  // <td key={index}>{maxPackC[cityName]} °C</td>
                  <td key={index}>
                    {maxPackC[cityName] !== null
                      ? `${maxPackC[cityName]} °C`
                      : "-"}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Max Temp - Pack D (°C) </td>
                {PLValue.map((cityName, index) => (
                  // <td key={index}>{maxPackD[cityName]} °C</td>
                  <td key={index}>
                    {maxPackD[cityName] !== null
                      ? `${maxPackD[cityName]} °C`
                      : "-"}
                  </td>
                ))}
              </tr>
            </table>
          </>
        ) : (
          <div className="no_data_slide3">
            <NoData />
          </div>
        )}
      </div>

      <div
        className="row mt-4"
        style={{ color: "black", paddingLeft: "35px", fontSize: "16px" }}
      >
        {" "}
        • There are {vinCount} vehicles which are showing abnormal max cell
        temperature during charging. For more details, please
        <br /> refer page no 6.
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "215px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});
export default ChargeFifth;
